import { render } from "./BlogDetalheView.vue?vue&type=template&id=ea595c2a"
import script from "./BlogDetalheView.vue?vue&type=script&lang=js"
export * from "./BlogDetalheView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__